import Lottie from "lottie-light-react";
import React from "react";
import useWindowWidth from "../../../hooks/useWindowWidth";
import shareDogIcon from "../../../images/png/social_share_dog.png";
import titleShape from "../../../static/img/sandyfur_shape.svg";
import dogAnimated from "../../../static/lottie/social-sharing-dog.json";
import { isSpecificSite } from "../../../utils/isSpecificSite";
import SocialMediaIcons from "../SocialMediaIcons";
import * as styles from "./SocialSharing.module.scss";

export interface SocialSharingProps {
	title: string;
	shareBodyText: string;
	sharePath: string;
	hasHighlightedTitle?: boolean;
}
export const SocialSharing: React.FC<SocialSharingProps> = ({
	title,
	shareBodyText,
	sharePath,
	hasHighlightedTitle,
}) => {
	isSpecificSite("uk", "SocialSharing");
	const windowWidth = useWindowWidth();
	return (
		<div
			className={
				hasHighlightedTitle
					? styles.socialmediawrapper
					: styles.socialmediawrapperprimary
			}
		>
			{hasHighlightedTitle ? (
				<h3 className={styles.sharetolabelhighlighted}>{title}</h3>
			) : (
				<>
					<img
						src={shareDogIcon}
						alt=""
						loading={"lazy"}
						aria-hidden={true}
						width={110}
						height={176}
						className={styles.dogstatic}
					/>
					<Lottie
						className={styles.doganimation}
						animationData={dogAnimated}
						aria-hidden
						loop={true}
					/>

					<div className={styles.sharetolabelcontainer}>
						<img
							src={titleShape}
							width={windowWidth >= 520 ? 237 : 271}
							height={windowWidth >= 520 ? 161 : 184}
							alt=""
							loading={"lazy"}
							aria-hidden={true}
						/>
						<p className={styles.sharetolabel}>{title}</p>
					</div>
				</>
			)}
			<SocialMediaIcons
				className={styles.sharetoicons}
				invert={true}
				xUrl={`https://twitter.com/intent/tweet?url=${sharePath}&via=DogsTrust&text=${shareBodyText}`}
				facebookUrl={`https://www.facebook.com/sharer/sharer.php?u=${sharePath}`}
				mailToUrl={`mailto:?subject=I saw this on the Dogs Trust’s website...&body=${shareBodyText} ${sharePath}`}
				whatsAppUrl={`https://wa.me/?text=${shareBodyText}: ${sharePath}`}
			/>
		</div>
	);
};

export default SocialSharing;
